import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';

import { ActionTypes } from '../constants/index';

const initState = {
  isAuthenticated: false,
  // isBetaSignedUp: false,
  needsUpdate: false,
  status: 'idle',
  token: null,
  device: null,
};

export const sessionReducer = createReducer(initState, {

  [ActionTypes.SESSION_SIGNUP_REQUEST](state) {
    return update(state, {
      status: { $set: 'running' },
      signupFormErrors: { $set: [] },
    });
  },

  [ActionTypes.SESSION_SIGNUP_SUCCESS](state, { payload }) {
    const { token } = payload;
    return update(state, {
      isAuthenticated: { $set: true },
      status: { $set: 'idle' },
      token: { $set: token },
      signupFormErrors: { $set: [] },
    });
  },

  [ActionTypes.SESSION_SIGNUP_FAILURE](state, { payload }) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      signupFormErrors: { $set: payload },
    });
  },

  [ActionTypes.SESSION_LOGIN_REQUEST](state) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'running' },
      loginFormErrors: { $set: [] },
    });
  },

  [ActionTypes.SESSION_LOGIN_SUCCESS](state, { payload }) {
    const { token } = payload;
    return update(state, {
      isAuthenticated: { $set: true },
      status: { $set: 'idle' },
      token: { $set: token },
      loginFormErrors: { $set: [] },
    });
  },

  [ActionTypes.SESSION_LOGIN_FAILURE](state, { payload }) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      token: { $set: null },
      loginFormErrors: { $set: payload },
    });
  },

  [ActionTypes.SESSION_FORGOT_REQUEST](state) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'running' },
      forgotFormErrors: { $set: [] },
      forgotFormSuccess: { $set: false },
    });
  },

  [ActionTypes.SESSION_FORGOT_SUCCESS](state) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      token: { $set: null },
      forgotFormErrors: { $set: [] },
      forgotFormSuccess: { $set: true },
    });
  },

  [ActionTypes.SESSION_FORGOT_FAILURE](state, { payload }) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      token: { $set: null },
      forgotFormErrors: { $set: payload },
      forgotFormSuccess: { $set: false },
    });
  },

  [ActionTypes.SESSION_RESET_REQUEST](state) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'running' },
      resetFormErrors: { $set: [] },
    });
  },

  [ActionTypes.SESSION_RESET_SUCCESS](state, { payload }) {
    return update(state, {
      isAuthenticated: { $set: true },
      status: { $set: 'idle' },
      token: { $set: payload },
      resetFormErrors: { $set: [] },
    });
  },

  [ActionTypes.SESSION_RESET_FAILURE](state, { payload }) {
    // console.log('SESSION_RESET_FAILURE called');
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      token: { $set: null },
      resetFormErrors: { $set: payload },
    });
  },

  [ActionTypes.SESSION_LOGOUT_REQUEST](state) {
    // console.log('SESSION_LOGOUT_REQUEST called');

    return update(state, {
      status: { $set: 'idle' },
      token: { $set: null },
      isAuthenticated: { $set: false },
    });
  },

  [ActionTypes.SESSION_LOGOUT_SUCCESS](state) {
    return state;
  },

  [ActionTypes.SESSION_LOGOUT_FAILURE](state) {
    return state;
  },

  [ActionTypes.SESSION_REGISTERFCM_REQUEST](state, { payload }) {
    return update(state, {
      device: { $set: payload.device },
    });
  },

  [ActionTypes.SESSION_REGISTERFCM_REQUEST_SUCCESS](state) {
    return state;
  },

  [ActionTypes.SESSION_REGISTERFCM_REQUEST_FAILURE](state) {
    return update(state, {
      device: { $set: null },
    });
  },


  [ActionTypes.SESSION_LOGIN_AUTH_CODE_REQUEST](state) {
    return update(state, {
      status: { $set: 'oauth_running' },
    });
  },

  [ActionTypes.SESSION_LOGIN_AUTH_CODE_SUCCESS](state, { payload }) {
    const { token } = payload;
    return update(state, {
      isAuthenticated: { $set: true },
      status: { $set: 'idle' },
      token: { $set: token },
    });
  },

  [ActionTypes.SESSION_LOGIN_AUTH_CODE_FAILURE](state) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      token: { $set: null },
    });
  },

  [ActionTypes.SESSION_SIGNUP_AUTH_CODE_REQUEST](state) {
    return update(state, {
      status: { $set: 'oauth_running' },
    });
  },

  [ActionTypes.SESSION_SIGNUP_AUTH_CODE_SUCCESS](state, { payload }) {
    const { token } = payload;
    return update(state, {
      isAuthenticated: { $set: true },
      status: { $set: 'idle' },
      token: { $set: token },
    });
  },

  [ActionTypes.SESSION_SIGNUP_AUTH_CODE_FAILURE](state) {
    return update(state, {
      isAuthenticated: { $set: false },
      status: { $set: 'idle' },
      token: { $set: null },
    });
  },

});



// WEBPACK FOOTER //
// ./scripts/reducers/session.js